import React, { forwardRef, useCallback } from 'react';
import { useTranslation } from 'next-i18next';

import AppTitle from '@/components/common/title';
import { Reciter } from '@/infrastructure/class/reciter';
import s from './styles.module.scss';

interface IReciterDescriptionProps {
  data: Reciter;
}

const ReciterDescription = forwardRef<HTMLDivElement, IReciterDescriptionProps>(
  (props, ref) => {
    const { data } = props;

    const { t: tCommon } = useTranslation('common');

    const renderReciterInfo = useCallback(() => {
      const __html = data.biblioHTMLEn ? data.biblioHTMLEn : data.biblioEn;
      return (
        <div
          className={s['bio-content']}
          dangerouslySetInnerHTML={{ __html }}
        />
      );
    }, [data]);

    return (
      <div className={s['container']}>
        <div id="scrollTarget" ref={ref} className={s['scroll-target']}></div>
        <AppTitle title={tCommon('reciterDescriptionTitle')} />
        <div className={s['description']}>
          <div>{renderReciterInfo()}</div>
        </div>
      </div>
    );
  }
);

ReciterDescription.displayName = 'ReciterDescription';

export default ReciterDescription;
